import { useEffect, useRef, useState } from "react";

/**
 * Avvolge un pulsante foto spento perche' il profilo e' offline, e ne spiega il
 * motivo solo quando l'utente lo cerca: hover da desktop, tap da mobile.
 *
 * PERCHE' NON IL Tooltip DI RADIX: il pulsante avvolto e' `disabled`, e un
 * elemento disabilitato non emette eventi puntatore — il trigger di Radix non
 * scatterebbe mai. Il giro consueto e' avvolgerlo in uno <span> che riceve gli
 * eventi al posto suo, che e' esattamente quello che fa questo componente; in
 * piu' qui serve anche il tap, perche' su mobile l'hover non esiste e la app e'
 * usata soprattutto da telefono.
 *
 * PERCHE' NON CAMBIARE L'ETICHETTA DEL PULSANTE: il nome dell'azione resta
 * leggibile anche da spento, cosi' si capisce cosa si potra' fare quando il
 * profilo torna online. Lo stato e' un'informazione accessoria e sta in un
 * livello accessorio.
 */
export function OfflinePhotoHint({
  name,
  children,
}: {
  /** Username del profilo, mostrato nel messaggio. */
  name?: string | null;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement | null>(null);

  // Da mobile il suggerimento si apre col tap e non ha un "mouse out" che lo
  // chiuda: lo chiudono un tocco fuori e un timer, altrimenti resterebbe li'.
  useEffect(() => {
    if (!open) return;
    const onDocDown = (e: PointerEvent) => {
      if (!wrapRef.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("pointerdown", onDocDown);
    const t = setTimeout(() => setOpen(false), 3000);
    return () => {
      document.removeEventListener("pointerdown", onDocDown);
      clearTimeout(t);
    };
  }, [open]);

  const message = name ? `${name} è offline` : "Profilo offline";

  return (
    <div
      ref={wrapRef}
      className="relative"
      // Il wrapper riceve gli eventi che il pulsante disabilitato non emette.
      onPointerEnter={(e) => {
        if (e.pointerType === "mouse") setOpen(true);
      }}
      onPointerLeave={(e) => {
        if (e.pointerType === "mouse") setOpen(false);
      }}
      onPointerDown={(e) => {
        if (e.pointerType !== "mouse") setOpen(true);
      }}
    >
      {children}
      {open && (
        <div
          role="tooltip"
          className="absolute bottom-full left-1/2 z-50 mb-1 -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-900 px-3 py-1.5 text-xs font-medium text-white shadow-md animate-in fade-in-0 zoom-in-95"
        >
          {message}
          <span className="absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-gray-900" />
        </div>
      )}
    </div>
  );
}
